<script>import { createEventDispatcher } from "svelte";
import { cn } from "../../utils/twClnm.js";
import CheckedIcon from "../../icons/CheckedIcon.svelte";
import UncheckedIcon from "../../icons/UncheckedIcon.svelte";
import ImageSelect from "../Filters/ImageSelect/ImageSelect.svelte";
import { writable } from "svelte/store";
export let value = "";
export let label = "";
export let group = [];
export let labelClass = "";
export let parentCheckedStates = null;
export let checkboxType = "input";
export let src = "";
export let limit = 0;
export let checked = false;
export let flag = writable({});
export let key = "";
const dispatch = createEventDispatcher();
const handleCheck = () => {
  group = limit ? [...group.filter((_, index) => index < limit - 1), value] : [...group, value];
};
const handleUncheck = () => {
  group = group.filter((checkedValue) => checkedValue !== value);
};
const onCheckboxClick = () => {
  if (key === "Marketplaces") {
    flag.update(() => {
      return false;
    });
  }
  if (parentCheckedStates) {
    parentCheckedStates;
  }
  !checked ? handleCheck() : handleUncheck();
  checked = group?.includes(value);
  dispatch("change", { checked });
};
const checkMarketPlaceDefault = () => {
  if ($flag) {
    handleCheck();
    return group?.includes(value);
  } else {
    return group?.includes(value);
  }
};
$: checked = key === "Marketplaces" ? checkMarketPlaceDefault() : group?.includes(value);
</script>

<label class={cn({'tw-flex tw-flex-row tw-items-center': true,  'tw-gap-1.5': label})}>
	<input
		type="checkbox"
		class="tw-absolute tw-left-0 tw-top-0 tw-hidden"
		{...$$restProps}
		id={value}
		value={value}
		on:click={onCheckboxClick}
	/>

	{#if checkboxType === 'input'}
		<div class={checked ? 'tw-block tw-h-5 tw-w-5' : 'tw-hidden'}><CheckedIcon /></div>
		<div class={!checked ? 'tw-block tw-h-5 tw-w-5' : 'tw-hidden'}><UncheckedIcon /></div>
		<div class={cn('tw-select-none', labelClass)}>{label}</div>
	{/if}

	{#if checkboxType === 'image'}
		<ImageSelect
			src={src}
			selected={checked}
			className="tw-w-full tw-h-full tw-object-contain tw-object-center"
		></ImageSelect>
	{/if}
</label>
